import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MessListComponent } from './mess-list/mess-list.component';
import { MessLinkComponent } from './mess-link/mess-link.component';
import { MessdetailsTableComponent } from './messdetails-table/messdetails-table.component';
import { MessInventoryComponent } from './mess-inventory/mess-inventory.component';
import { MessDoDetailsComponent } from './mess-do-details/mess-do-details.component';
import { MessDoDetailViewComponent } from './mess-do-detail-view/mess-do-detail-view.component';
import { MessClosedDetailsComponent } from './mess-closed-details/mess-closed-details.component';
import { MessExcelComponent } from './mess-excel/mess-excel.component';
import { MealRequestComponent } from './meal-request/meal-request.component';
import { MealOrderSummaryComponent } from './meal-order-summary/meal-order-summary.component';
import { AdminDashboardComponent } from './admin-dashboard/admin-dashboard.component';
import { AddNewMenuItemComponent } from './add-new-menu-item/add-new-menu-item.component';
import { AdminDivisionReportComponent } from './admin-division-report/admin-division-report.component';
import { AdminMessInventoryComponent } from './admin-mess-inventory/admin-mess-inventory.component';
import { MessLandingPageComponent } from './mess-landing-page/mess-landing-page.component';

const routes: Routes = [
  {
    path: '', component: MessLinkComponent,
    children: [
      { path: '', redirectTo: 'MessDetails', pathMatch: 'full' },
      { path: 'MessDetails', component: MessLandingPageComponent },
      { path: 'messDetailsInventory', component: MessInventoryComponent },
      { path: 'messDoDetails', component: MessDoDetailsComponent },
      { path: 'messDoDetailsView', component: MessDoDetailViewComponent },
      { path: 'messClosedDetails', component: MessClosedDetailsComponent },
      { path: 'messExcelDetails', component: MessExcelComponent },
      { path: 'mealRequest', component: MealRequestComponent },
      { path: 'mealOrderSummary', component: MealOrderSummaryComponent },
      { path: 'adminDashboardReports', component: AdminDashboardComponent },
      { path: 'adminDivisionReport', component: AdminDivisionReportComponent },
      { path: 'addNewMenuItem', component: AddNewMenuItemComponent },
      { path: 'adminMessInventory', component: AdminMessInventoryComponent },
    ]
  }

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MessDetailsRoutingModule { }
